export default "__VITE_ASSET__9d483258__"